'use client';

import { createContext, useContext } from 'react';

export interface IServerContext {
  isMobileDevice: boolean;
  countryCode: string;
  hostname: string;
}

export const ServerEnvContext = createContext<IServerContext | null>(null);

export const useServer = () => {
  const context = useContext(ServerEnvContext);
  if (!context) throw new Error('ServerEnvContext is missing');
  return context;
};
